module.exports = __webpack_public_path__ + "img/tools.cbd863ab.svg";